const clamp = (value: number, min = 0, max = 100) => Math.max(min, Math.min(max, value));

export type BudgetInvestmentState = "low" | "balanced" | "strong";

export const getBudgetInvestmentStatus = (level?: number) => {
  if (level === undefined || Number.isNaN(level)) {
    return { score: undefined, state: undefined };
  }

  if (level < 25) {
    return { score: 18, state: "low" as const };
  }
  if (level < 44) {
    return { score: 55, state: "balanced" as const };
  }
  return { score: 88, state: "strong" as const };
};

export type TeamHypeState = "low" | "steady" | "high";

export const getTeamHypeStatus = (hype?: number) => {
  if (hype === undefined || Number.isNaN(hype)) {
    return { score: undefined, state: undefined };
  }

  if (hype < 0.35) {
    return { score: 18, state: "low" as const };
  }
  if (hype < 0.65) {
    return { score: 55, state: "steady" as const };
  }
  return { score: 88, state: "high" as const };
};

export type FinanceCapState = "available" | "near" | "over";

export const getFinanceCapStatus = ({
  capSpace,
  payrollLimit,
}: {
  capSpace?: number;
  payrollLimit?: number;
}) => {
  if (capSpace === undefined || payrollLimit === undefined || payrollLimit <= 0) {
    return { score: undefined, state: undefined };
  }

  const ratio = capSpace / payrollLimit;
  if (capSpace < 0) {
    return {
      score: clamp(35 + ratio * 100, 0, 35),
      state: "over" as const,
    };
  }
  if (ratio < 0.08) {
    return {
      score: clamp(48 + ratio * 150, 48, 60),
      state: "near" as const,
    };
  }
  return {
    score: clamp(65 + ratio * 180, 65, 100),
    state: "available" as const,
  };
};

export type ContractQueueFitState = "allowed" | "fits" | "tight" | "over";

export const getContractQueueFitStatus = ({
  capSpace,
  salaryCapType,
  totalAsking,
}: {
  capSpace: number;
  salaryCapType: "hard" | "none" | "soft";
  totalAsking: number;
}) => {
  if (salaryCapType !== "hard") {
    return { score: 88, state: "allowed" as const };
  }

  const remaining = capSpace - totalAsking;
  if (remaining < 0) {
    return { score: 18, state: "over" as const };
  }
  if (capSpace <= 0 || remaining / capSpace < 0.15) {
    return { score: 55, state: "tight" as const };
  }
  return { score: 88, state: "fits" as const };
};
